import { Component, ViewChild, HostListener } from "@angular/core";
import { FieldType } from "@kre-form/core";
import { KreFormFieldIonTextI18Component } from "../components/texti18_component";
import { KreFormIonDialogService } from "../tools/dialog.service";

@Component({
  selector: "kreform-field-ion-texti18n",
  template: `
    <ng-container>
      <ion-item detail="true" (click)="openPicker()">
        <div>{{ textlanguage }}</div>
      </ion-item>
    </ng-container>
  `,
})
export class KreFormFieldIonTextI18n extends FieldType {
  constructor(public dialogService: KreFormIonDialogService) {
    super();
  }
  languageList: Array<any> = [
    { language: "chinese", label: "中", value: "" },
    { language: "english", label: "英", value: "" },
  ];

  get textlanguage() {
    let result = "";
    if (
      this.model &&
      this.model[this.key] &&
      Array.isArray(this.model[this.key])
    ) {
      this.model[this.key].forEach((element) => {
        if (element.language == "chinese") {
          result = element.value;
        }
      });
    }
    return result;
  }

  openPicker() {
    let languages = [];
    this.languageList.forEach((item: any) => {
      languages.push({
        language: item.language,
        label: item.label,
        value: this.getLanguageValue(item.language),
      });
    });
    let params = {
      languageList: languages,
      required: this.to.required != undefined ? this.to.required : false,
      editor: this.editor,
    };
    this.dialogService.CreateModelDialog(
      {
        content: KreFormFieldIonTextI18Component,
        class: "full-page",
      },
      params,
      (instance: any, modal: any) => {
        if (instance) {
          this.formControl.patchValue(instance);
          this.formControl.markAsTouched();
        }
      }
    );
  }
}
